import { render, staticRenderFns } from "./LinearProgressNum.vue?vue&type=template&id=2b0d8878&scoped=true&"
import script from "./LinearProgressNum.vue?vue&type=script&lang=js&"
export * from "./LinearProgressNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0d8878",
  null
  
)

export default component.exports